<button
  (click)="openConfig.emit()"
  class="config-panel-toggle slc-btn-fab-brand"
  mat-fab
  type="button">
  <mat-icon svgIcon="mat:settings"></mat-icon>
</button>
